// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"1ae4a57b7ca0d01f","6831":"1ef5176e4170580f","8503":"36f450739e5c48f4","9683":"c027f15bd8c68b13"}[chunkId] + ".js";
};